import { ENTITY_PART_TYPE_TCE } from '_legacy/models/common/EntityPart';

export const balticOptions = [
    { label: 'Baltic 38', value: 'Baltic 38', displayName: 'B38' },
    { label: 'Baltic 58', value: 'Baltic 58', displayName: 'B58' },
    { label: 'Baltic 63', value: 'Baltic 63', displayName: 'B63' },
    { label: 'Baltic 74', value: 'Baltic 74', displayName: 'B74' },
    { label: 'Baltic 82', value: 'Baltic 82', displayName: 'B82' },
    { label: 'Baltic 180', value: 'Baltic 180', displayName: 'B180' },
    { label: 'Baltic 182', value: 'Baltic 182', displayName: 'B182' },
];

class TceFormatter {
    numberFormat = new Intl.NumberFormat('en-GB');

    numberFormatForDecimalValues = new Intl.NumberFormat('en-GB', {
        minimumFractionDigits: 2,
    });

    startValueForHidingDecimals = 1000;

    format(part) {
        if (!part) {
            return '';
        }

        if (part.partType === ENTITY_PART_TYPE_TCE) {
            const ballastBonus = part.tceValue.ballastBonus
                ? ` $${this.formatNumber(part.tceValue.ballastBonus)} BB`
                : '';
            const balticIndexDisplayName = part.tceValue.balticIndex
                ? balticOptions.find(
                      (x) => x.value === part.tceValue.balticIndex
                  )?.displayName
                : undefined;
            const balticIndex = part.tceValue.balticIndex
                ? ` ${balticIndexDisplayName}`
                : '';
            return `$${this.formatNumber(
                part.tceValue.rate
            )}${ballastBonus}${balticIndex} D ${
                part.tceValue.delivery.name
            } R ${part.tceValue.redelivery.name}`;
        } else {
            return part.separatorValue;
        }
    }

    formatNumber(value) {
        if (isNaN(value)) {
            return '';
        }

        return this.numberFormat.format(value);
    }
}

const tceFormatterInstance = new TceFormatter();

export { TceFormatter, tceFormatterInstance };
